// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.title[data-v-5f34aa20]{\n\tfont-weight: bold;\n}\n.note[data-v-5f34aa20] {\n\tcolor: var(--main-gray-5);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
